module.exports = __webpack_public_path__ + "media/images/athletes/1820-61c090f6b1cb01cb2fe9a6f9bce040ad.png";